import moment from "moment";

const formatDate = (date: Date, format: string): string => moment(date).format(format);
export default formatDate;
